import { render } from "./AddOnCreation.vue?vue&type=template&id=6dd3d4ef&scoped=true"
import script from "./AddOnCreation.vue?vue&type=script&lang=js"
export * from "./AddOnCreation.vue?vue&type=script&lang=js"

import "./AddOnCreation.vue?vue&type=style&index=0&id=6dd3d4ef&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd3d4ef"]])

export default __exports__